const tips = [
    {
        title: 'Safety First', 
        text: 'Make sure first aid and life saving equipment, such as a life preserver, is always kept close to the pool.',
        id: 'tips1'
    },
    {
        title: 'Be Attentive', 
        text: 'Never leave children unattended in or around the pool.',
        id: 'tips2'
    },
    {
        title: 'Keep it Clean', 
        text: 'Always make sure that all toys and pool accessories (such as floating mattresses) are taken out of the pool when you are done using it. Toys left behind in the pool may lure a child back to the pool when an adult is not present.',
        id: 'tips3'
    },
    {
        title: 'Weather Permitting', 
        text: 'Keep an eye on the weather. It is extremely dangerous to be in or around the pool during an electrical storm, so you should head inside if the sky darkens.',
        id: 'tips4'
    },
    {
        title: 'Be Prepared', 
        text: 'Consider enrolling in a CPR course. No one wants to think of the worst, but being prepared for it doesn\'t hurt and may mean life instead of death.',
        id: 'tips5'
    },
    {
        title: 'Have Protection', 
        text: 'Fun in the sun around the swimming pool is a great way to spend a Saturday afternoon, but too much fun may amount to sunburns, especially in younger children. Make sure everyone is wearing waterproof sunscreen, and keep babies and infants in the shade when they are not in the water.',
        id: 'tips6'
    }
];

export default tips;